/**
 * @generated SignedSource<<b21ad558edf5b5582bfb5c41ee7ba311>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productsPrintTypesQuery$variables = Record<PropertyKey, never>;
export type productsPrintTypesQuery$data = {
  readonly modelsHierarchy: ReadonlyArray<{
    readonly code: string;
    readonly colors: ReadonlyArray<{
      readonly colorID: string;
      readonly name: string;
      readonly sides: ReadonlyArray<{
        readonly name: string;
        readonly sideID: string;
      }>;
    }>;
    readonly isDemo: boolean;
    readonly name: string;
    readonly productID: string;
    readonly providerID: number;
  }>;
};
export type productsPrintTypesQuery = {
  response: productsPrintTypesQuery$data;
  variables: productsPrintTypesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProductHierarchy",
    "kind": "LinkedField",
    "name": "modelsHierarchy",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isDemo",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "productID",
        "storageKey": null
      },
      (v0/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "providerID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductHierarchyColor",
        "kind": "LinkedField",
        "name": "colors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "colorID",
            "storageKey": null
          },
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductHierarchySide",
            "kind": "LinkedField",
            "name": "sides",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sideID",
                "storageKey": null
              },
              (v0/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "productsPrintTypesQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "productsPrintTypesQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "d54b0530858803e1baa1b23316dcc211",
    "id": null,
    "metadata": {},
    "name": "productsPrintTypesQuery",
    "operationKind": "query",
    "text": "query productsPrintTypesQuery {\n  modelsHierarchy {\n    isDemo\n    productID\n    name\n    code\n    providerID\n    colors {\n      colorID\n      name\n      sides {\n        sideID\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "08847afe67e6d26847f5d5c757bee14a";

export default node;
